import { render, staticRenderFns } from "./HeaderPortfoliosNavigation.vue?vue&type=template&id=2b91c11c&"
import script from "./HeaderPortfoliosNavigation.vue?vue&type=script&lang=js&"
export * from "./HeaderPortfoliosNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports